import { Skeleton } from "@tql/ui-components-react/tql/indicators";
import type { ReactNode } from "react";

import styles from "./address-book-card.module.css";

type AddressBookCardProps = {
	/** Rendered before the title, e.g. a selection checkbox or a default badge. */
	leading?: ReactNode;
	title: ReactNode;
	/** Right-aligned action buttons, e.g. Edit/Favorite/Delete. */
	actions?: ReactNode;
	/** Body content - each consumer renders its own field layout using `.fieldGroup`/`.fieldLabel`. */
	children: ReactNode;
	"data-testid"?: string;
};

/** Shared card shell for mobile Address Book lists (settings page and the shared modal). */
export const AddressBookCard = ({
	leading,
	title,
	actions,
	children,
	"data-testid": testId = "address-card",
}: AddressBookCardProps) => (
	<div className={styles.card} data-testid={testId}>
		<div className={styles.cardHeaderRow}>
			<div className={styles.titleGroup}>
				{leading}
				<div className={styles.title}>{title}</div>
			</div>
			{actions ? <div className={styles.actions}>{actions}</div> : null}
		</div>
		{children}
	</div>
);

export const AddressBookCardSkeleton = () => (
	<div className={styles.card} data-testid={"address-card-skeleton"}>
		<div className={styles.cardHeaderRow}>
			<span className={styles.skeletonText}>
				<Skeleton animation={{ type: "wave" }} shape={"text"} />
			</span>
			<span className={styles.skeletonAction}>
				<Skeleton animation={{ type: "wave" }} shape={"rectangle"} />
			</span>
		</div>
		<span className={styles.skeletonText}>
			<Skeleton animation={{ type: "wave" }} shape={"text"} />
		</span>
		<span className={styles.skeletonText}>
			<Skeleton animation={{ type: "wave" }} shape={"text"} />
		</span>
	</div>
);

export { default as addressBookCardStyles } from "./address-book-card.module.css";
